<template>
   <v-dialog
      :model-value="true"
      persistent
      scrollable
      :width="width"
      @click:outside="onClickOutside()"
      @keydown.esc="onClickOutside()"
   >
      <v-card>
         <v-card-title dialog-header>
            <span title-medium>{{ title }}</span>
         </v-card-title>
         <v-card-text>
            <p>{{ text }}</p>
            <slot></slot>
         </v-card-text>
         <v-card-actions dialog-footer>
            <v-spacer></v-spacer>
            <v-btn
               v-if="!acceptOnly"
               variant="text"
               size="large"
               :color="cancelColor"
               @click="$emit('cancel')"
            >
               {{ cancelText }}
            </v-btn>
            <v-btn variant="flat" size="large" :color="acceptColor" @click="$emit('confirm')">
               {{ acceptText }}
            </v-btn>
         </v-card-actions>
      </v-card>
   </v-dialog>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

interface ICompData {
   show: boolean;
}

export default defineComponent({
   components: {},
   emits: {
      cancel: () => true,
      confirm: () => true,
   },
   props: {
      title: {
         type: String,
         default: '',
      },
      text: {
         type: String,
         default: '',
      },
      acceptOnly: {
         type: Boolean,
         default: false,
      },
      acceptText: {
         type: String,
         default: 'Accept',
      },
      acceptColor: {
         type: String,
         default: 'primary',
      },
      cancelText: {
         type: String,
         default: 'Cancel',
      },
      cancelColor: {
         type: String,
         default: '',
      },
      width: {
         type: String,
         default: '500px',
      },
   },
   data(): ICompData {
      return {
         show: true,
      };
   },
   methods: {
      onClickOutside(): void {
         this.$emit('cancel');
      },
   },
});
</script>
